<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <top-nav id="topmenu-container" class="topmenu-container" v-if="topNav" />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <search id="header-search" class="right-menu-item" />

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <!-- <el-tooltip content="布局大小" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->
        <!-- <div class="inform-bell-wrapper right-menu-item">
          <img src="@/assets/images/inform.png" alt="" class="inform-bell" />
          <span class="inform-badge">9</span>
        </div> -->
      </template>

      <el-dropdown class="avatar-container right-menu-item avatar-dropdown jk-cursor-pointer" trigger="click">
        <div class="avatar-wrapper avatar-dropdown-btn">
          <span class="avatar-name">{{ userName }}</span>
          <i class="el-icon-caret-bottom avatar-caret" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/user/profile">
            <el-dropdown-item>个人中心</el-dropdown-item>
          </router-link>
          <el-dropdown-item @click.native="setting = true">
            <span>布局设置</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import TopNav from '@/components/TopNav';
  import Hamburger from '@/components/Hamburger';
  import Screenfull from '@/components/Screenfull';
  import SizeSelect from '@/components/SizeSelect';
  import Search from '@/components/HeaderSearch';

  export default {
    components: {
      TopNav,
      Hamburger,
      Screenfull,
      SizeSelect,
      Search,
    },
    computed: {
      ...mapGetters(['sidebar', 'avatar', 'device']),
      userName() {
        return this.$store.state.user.name;
      },
      setting: {
        get() {
          return this.$store.state.settings.showSettings;
        },
        set(val) {
          this.$store.dispatch('settings/changeSetting', {
            key: 'showSettings',
            value: val,
          });
        },
      },
      topNav: {
        get() {
          return this.$store.state.settings.topNav;
        },
      },
    },
    methods: {
      toggleSideBar() {
        this.$store.dispatch('app/toggleSideBar');
      },
      async logout() {
        this.$confirm('确定退出系统吗？', '', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          customClass: 'plan-delete-confirm', // 可自定义样式
          center: true,
          showClose: false,
        })
          .then(() => {
            this.$store.dispatch('LogOut').then(() => {
              location.href = process.env.VUE_APP_CONTEXT_PATH + 'index';
            });
          })
          .catch(() => {});
      },
    },
  };
</script>

<style lang="scss" scoped>
  .navbar {
    height: 50px;
    overflow: hidden;
    position: relative;
    background: #eff3fc;

    .hamburger-container {
      display: flex;
      align-items: center;
      height: 100%;
      float: left;
      cursor: pointer;
      transition: background 0.3s;
      -webkit-tap-highlight-color: transparent;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }

    .breadcrumb-container {
      float: left;
    }

    .topmenu-container {
      position: absolute;
      left: 50px;
    }

    .errLog-container {
      display: inline-block;
      vertical-align: top;
    }

    .right-menu {
      display: flex;
      align-items: center;
      float: right;
      height: 100%;
      line-height: 50px;

      &:focus {
        outline: none;
      }

      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background 0.3s;

          &:hover {
            background: rgba(0, 0, 0, 0.025);
          }
        }
      }

      .inform-bell-wrapper {
        margin: 0 30px;
        position: relative;
        display: inline-block;
        width: 30px;
        height: 30px;
        vertical-align: middle;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        border-radius: 8px;
        .inform-bell {
          width: 26px;
          height: 26px;
        }
        .inform-badge {
          position: absolute;
          top: -2px;
          right: -2px;
          min-width: 12px;
          height: 12px;
          background: #f5222d;
          color: #fff;
          font-size: 12px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 0 2px #fff;
          padding: 0 4px;
          z-index: 2;
          font-weight: bold;
        }
      }
      .avatar-container.avatar-dropdown {
        display: flex;
        align-items: center;
        margin-right: 30px;
        .avatar-dropdown-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;
          border: 1px solid #a0c0f9;
          border-radius: 7px;
          height: 30px;
          min-width: 120px;
          box-sizing: border-box;
          font-size: 13px;
          color: #005aff;
          font-weight: 500;
          .avatar-name {
            color: #005aff;
            font-size: 16px;
            font-weight: 500;
            padding-left: 15px;
          }
          .avatar-caret {
            color: #005aff;
            font-size: 22px;
            margin-left: 12px;
            margin-right: 8px;
          }
        }
      }
    }
  }
</style>
